<template>
  <div class="pic">
    <img :src="src" alt="壁纸">
  </div>
</template>

<script>
export default {
  name: 'Wallpaper',
  props: {
    src: {
      type: String,
      default() {
        return ''
      }
    }
  }
}
</script>

<style scoped>
  .pic {
    height: 360px;
  }
  .pic img {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-width:768px) {
    .pic {
      height: 200px;
    }
  }
</style>
